import { DocumentItemProps } from "./types";
import styles from "./styles.module.scss";

export function DocumentItem({ title, onSearch }: DocumentItemProps) {
	return (
		<div className={styles.documentItem}>
			<span className={styles.title}>{title}</span>
			<button type="button" onClick={onSearch} className={styles.searchButton}>
				buscar
			</button>
		</div>
	);
}
